module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/octopus-portuguese.8804d069.jpg";